<template>
  <!-- locally installed, namespaced sticky -->
  <div
    class="col-lg-4"
    id="checkoutSectionContainer"
    :class="{ 'd-none d-lg-block': hide }"
  >
    <affix
      :style="{ width: newWidth }"
      relative-element-selector="#menu-section"
      :offset="{ top: 170, bottom: 20, padding: 0 }"
    >
      <h6 class="affix-title">{{ $t("text.checkout") }}</h6>
      <cart-details
        :action="action"
        :showTable="false"
        :hide="hide"
      ></cart-details>
    </affix>
  </div>
</template>
<script>
import CartDetails from "./CartDetails";
import { Affix } from "@/components";
export default {
  name:'checkout-section',
  components: {
    CartDetails,
    Affix
  },
  props: {
    action: String,
    hide: Boolean
  },
  data() {
    return {
      newWidth: "100%"
    };
  },
  methods: {
    OnResize() {
      var element = document.getElementById("checkoutSectionContainer");
      if (element) {
        var positionInfo = element.getBoundingClientRect();
        this.newWidth = positionInfo.width - 30 +"px";
      }
    }
  },
  mounted() {
    this.OnResize();
    this.$nextTick(()=>{
      window.addEventListener("resize", this.OnResize);
    })
  },
  beforeDestroy(){
    window.removeEventListener("resize", this.OnResize)
  }
};
</script>

